import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import 'primeflex/primeflex.css';
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import App from './App';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);